export default "__VITE_ASSET__ibI2N99E__"